import React from 'react';
import { connect } from 'react-redux';
import { MenuItem } from 'react-bootstrap';
import { customersRequest, setCustomers } from 'actions/customers/list';
import Dropdown from 'components/Dropdown';
import { Field, reduxForm } from 'redux-form';
import SearchBar from 'components/Fields/ReduxForm/SearchBar';
import { showPageLoadingSpinner } from 'actions/loadingSpinner';
import { isFullSiteMode } from 'utils/fullSite';
import LoyaltyBanner from './LoyaltyBanner';
import styles from './ActionBar.css';
import MenuTitleLoyalty from '../../../Loyalty/Components/MenuTitleLoyalty';

class ActionBar extends React.Component {
  render() {
    const { onClickImport, onClickExport } = this.props;

    return (
      <div>
        <div className={`row ${styles['menu-title-loyalty-row']}`}>
          <MenuTitleLoyalty
            menuTitle="Customer List"
            loyaltySubscription={this.props.loyaltySubscription}
            goToSubscribeView={this.props.goToSubscribeView}
          />
          {!isFullSiteMode() && (
            <div className="col-sm-4 col-xs-4 pull-right col-md-4  action-customer-list">
              <div className="pull-right">
                <Dropdown>
                  <Dropdown.Toggle
                    title="Import / Export"
                    bsStyle="primary"
                  ></Dropdown.Toggle>
                  <Dropdown.Menu>
                    <MenuItem onSelect={onClickImport}>
                      Import Customer
                    </MenuItem>
                    <MenuItem divider />
                    <MenuItem onSelect={onClickExport}>
                      Export Customer
                    </MenuItem>
                  </Dropdown.Menu>
                </Dropdown>
              </div>
            </div>
          )}
        </div>
        <LoyaltyBanner />
        <div className={styles.wrapper}>
          <div className="row">
            <div className="col-sm-3 col-xs-4 search-customer-list">
              <Field
                name="keyword"
                component={SearchBar}
                onChange={this._onChangeKeyword}
                placeholder="Name, email, phone"
                className="searchbar-customerlist"
              />
            </div>
          </div>
        </div>
      </div>
    );
  }

  _onChangeKeyword = (event, keyword) => {
    const { dispatch } = this.props;
    dispatch(setCustomers([]));
    dispatch(showPageLoadingSpinner(true));
    dispatch(
      customersRequest(
        {
          page: 1,
          keyword: keyword.trim(),
        },
        []
      )
    );
  };
}

ActionBar.propTypes = {};

const mapForm = {
  form: 'search',
};

function mapStateToProps(state) {
  return {
    data: {
      customers: {
        list: state.customers.list,
      },
    },
  };
}
export default connect(mapStateToProps)(reduxForm(mapForm)(ActionBar));
